var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowCircleLeft component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowCircleLeft extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9 21.2998C6.71 21.2998 2.5 17.0898 2.5 11.8998C2.5 6.7098 6.71 2.49981 11.9 2.4998C17.09 2.4998 21.3 6.7098 21.3 11.8998C21.3 17.0898 17.08 21.2998 11.9 21.2998ZM1 11.8998C1 17.9198 5.88 22.7998 11.9 22.7998C17.92 22.7998 22.8 17.9198 22.8 11.8998C22.8 5.8798 17.92 0.999805 11.9 0.999805C5.88 0.999805 0.999999 5.8898 1 11.8998ZM6.61 12.3498C6.61 12.3498 6.66 12.4098 6.69 12.4398L9.02 14.7698C9.31 15.0598 9.79 15.0598 10.08 14.7698C10.37 14.4798 10.37 13.9998 10.08 13.7098L9.02 12.6498L16.57 12.6498C16.98 12.6498 17.32 12.3098 17.32 11.8998C17.32 11.4898 16.98 11.1498 16.57 11.1498L9.02 11.1498L10.08 10.0898C10.37 9.7998 10.37 9.3198 10.08 9.0298C9.79 8.7398 9.31 8.7398 9.02 9.0298L6.68 11.3698C6.6 11.4498 6.54 11.5498 6.5 11.6498C6.47 11.7298 6.46 11.8098 6.46 11.8998C6.46 12.0198 6.49 12.1398 6.54 12.2398C6.56 12.2798 6.58 12.3098 6.61 12.3498V12.3498Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowCircleLeft.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowCircleLeft.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowCircleLeft.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-circle-left') === undefined) {
    customElements.define('cat-icon-arrow-circle-left', BlocksIconArrowCircleLeft);
}
